import { DomainEvent } from '../../../../core/domain/events/domain_event';
import { ToDo } from '../todo';

export class ToDoEvent extends DomainEvent<ToDo> {}

export class ToDoCreatedEvent extends ToDoEvent {}

export class ToDoUpdatedEvent extends ToDoEvent {}

export class ToDoRemovedEvent extends ToDoEvent {}
